import { render } from "./AsetPerusahaan.vue?vue&type=template&id=6f86fd0e"
import script from "./AsetPerusahaan.vue?vue&type=script&lang=js"
export * from "./AsetPerusahaan.vue?vue&type=script&lang=js"

import "./AsetPerusahaan.vue?vue&type=style&index=0&id=6f86fd0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__